import axios from 'axios';

export const fetchDomain = async () => {
  try {
    const token = localStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    
    const fetchDomainUrl = process.env.REACT_APP_FETCH_DOMAIN_URL ? process.env.REACT_APP_FETCH_DOMAIN_URL : '';
    const response = await axios.get(fetchDomainUrl, { headers });
    return response?.data;
  } catch (error) {
    console.log('Error fetching data:', error);
    return error;
  }
};

export const addDomain = async (org: string[]) => {
  try {
    const token = localStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    
    const addDomainUrl = process.env.REACT_APP_ADD_DOMAIN_URL
      ? process.env.REACT_APP_ADD_DOMAIN_URL
      : '';
    const listOfDomains = org.map((item) => ({
      domain: item,
    }));
    const response = await axios.post(addDomainUrl, listOfDomains, { headers });
    return response?.data || {};
  } catch (error) {
    console.log('Error adding data:', error);
    return {};
  }
};

export const deleteDomain = async (id: string | number) => {
  try {
    const token = localStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    
    const deleteDomainUrl = process.env.REACT_APP_DELETE_DOMAIN_URL || '';
    if (!deleteDomainUrl) {
      console.log('Missing REACT_APP_DELETE_DOMAIN_URL');
      return {};
    }
    // send id in the body using axios.delete's config.data
    const response = await axios.post(deleteDomainUrl, { "id" : id }, { headers });
    return response?.data || {};
  } catch (error) {
    console.log('Error deleting domain:', error);
    return {};
  }
};
